{
  "kk": {
    "freeLabel": {
      "title": "Тегін"
    }
  },
  "ru": {
    "freeLabel": {
      "title": "Бесплатно"
    }
  },
  "en": {
    "freeLabel": {
      "title": "Free"
    }
  }
}
